import React, { useState } from 'react';
import TableButtons from '../table-buttons/TableButtons';
import { Checkbox, TextField } from 'material-ui';

import { updateBadFitItem } from 'service/api';
import { useDispatch } from 'react-redux';
import { showMessage } from 'modules/messages/actions';

import './bad-fit-item.scss'
import { failedMessage } from 'service/constants';
import { updateBadItem } from 'modules/admin/redux/actions';

const BadFitItem = ({isGrey, clientName, counsellorName, notes, id}) => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)

    const checkboxHandler = async () => {
        try {
            setLoading(true)
            const badFitItem = await updateBadFitItem(id, {isGrey: true})
            dispatch(updateBadItem(badFitItem))
        } catch {
            dispatch(showMessage(failedMessage))
        } finally {
            setLoading(false)
        }
    }

    return (
        <section className="invoice-line-item-container">
            <article 
                className={`invoice-line-item bad-fit-container ${isGrey ? "grey" : ""}`}
            >
                <Checkbox
                    color="default"
                    className="bad-fit-checkbox"
                    checked={isGrey}
                    disabled={loading}
                    onClick={checkboxHandler}
                />
                <span className="flex-20" style={{flex: "10% 0.5"}}>
                    {clientName}
                </span>
                <span className="flex-20" style={{flex: "10% 0.5"}}>
                    {counsellorName}
                </span>
                <span className="flex-20" style={{flex: "12% 2"}}>
                    <TextField
                        className='notes-input'
                    />
                    {notes}
                    <TableButtons
                        badFitId={id}
                    />
                </span>
            </article>
        </section>
    );
};

export default BadFitItem;
